import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Text = makeShortcode("Text");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <Text sx={{
      fontSize: [4, 5, 6],
      fontWeight: `bold`,
      color: `heading`
    }} mdxType="Text">
  Hi.
    </Text>
    <p>{`I'm Luis.`}</p>
    <p>{`I am a Software Engineer who likes to develop solutions for modern world technical challenges, continuous improver who believes that everything needs to be in constant change, evolving, and adapting.`}</p>
    <p>{`I am currently working as a Principal Software Engineer at `}<a parentName="p" {...{
        "href": "https://healthcare.com"
      }}>{`HealthCare.com`}</a>{`, overseeing the Cloud Infrastructure, Software Architecture, and guiding the DevOps culture implementation.`}</p>
    <p>{`Besides working with technology, I enjoy cooking, listening to music, playing video games, and weight lifting.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      